import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { loadHmrcData } from '../../../../store/participantService';
import { DEFAULT_TABLE_ROWS_PER_PAGE } from '../../../../utils/formValidation/commonConstants';
import { stableSort } from '../../../../utils/sortFunctions';
import { uuid } from '../../../../utils/stringUtils';
import ResultsTable from '../../../table/ResultsTable';
import LoadingSpinner from '../../../ui/LoadingSpinner';

import HmrcDataTableRow from './HmrcDataTableRow';

import app from '../../../../app.module.css';
import local from '../../requests/requests.module.css';

const headCells = [
    { id: 'notificationType', numeric: false, label: 'Notification Type' },
    { id: 'notificationDate', numeric: false, label: 'Notification Date' },
    { id: 'eventDate', numeric: false, label: 'Event Date' },
    { id: 'dateUploaded', numeric: true, label: 'Date Uploaded' }
];

const initialRowMetaData = {
    order: 'desc',
    orderBy: 'notificationDate',
    page: 0,
    rowsPerPage: DEFAULT_TABLE_ROWS_PER_PAGE
};

const HmrcData = () => {
    // HOOKS
    const dispatch = useDispatch();

    // LOCAL STATE
    const [rows, setRows] = useState([]);
    const [rowMetaData, setRowMetaData] = useState(initialRowMetaData);

    // STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const hmrcData = useSelector((state) => state.entities.participantService.hmrcData);

    // USE EFFECTS
    useEffect(() => {
        setRows([]);
        if (!currentParticipant?.id) return;
        dispatch(loadHmrcData(currentParticipant.id));
    }, [currentParticipant]);

    useEffect(() => {
        if (hmrcData?.length < 1) return;
        const updatedRows = hmrcData.map((el) => ({
            ...el,
            id: uuid()
        }));
        setRows(updatedRows);
    }, [hmrcData]);

    // HELPER fNS
    const createRows = () =>
        stableSort(rows, rowMetaData.orderBy, rowMetaData.order).map((el) => (
            <HmrcDataTableRow key={el.id} row={el} />
        ));

    // RENDER
    return (
        <div className={local.sectionWrapper}>
            <h2 className={app.sectionHeading}>HMRC Data</h2>
            {rows.length < 1 ? (
                <LoadingSpinner content="No HMRC data found" />
            ) : (
                <ResultsTable
                    defaultOrderBy={rowMetaData.orderBy}
                    sortOrder={rowMetaData.order}
                    headCells={headCells}
                    passRowMetaDataUp={setRowMetaData}
                    tableRows={createRows()}
                    totalResults={rows.length}
                />
            )}
        </div>
    );
};

export default HmrcData;
